import { PenDesignTypeDto } from './PenDesignType';
import { PenDimensionPipeDto } from './PenDimensionPipe';

export class PenDimensionDto {
  Id: number;
  CirumferenceInnerPipe: number;
  PipeCount: number;
  NetStandardId: number;
  HasBottomRing: boolean;
  BracketsTotal: number;
  BracketsMooring: number;
  BracketsEvenlyDistr: number;
  PenDesignTypeId: number;
  PenDesignType: PenDesignTypeDto;
  MaterialClass: string;
  DesignBrackets: string;
  CapacityNetAttachmentULS: string;
  CapacityNetAttachmentALS: string;
  CapacityBottomRingSuspensionULS: string;
  CapacityBottomRingSuspensionALS: string;
  PenBridleConfigId: number;
  UserManualId: number;
  BulkHeadDistance: number;
  BottomRingDepth: number;
  RailingSDR: number;
  RailingDiameter: number;
  RailingSegmentLength: number;
  WalkwaySDR: number;
  WalkwayDiameter: number;

  PenDimensionPipes: PenDimensionPipeDto[];
}

export class UpdatePenDimension {
  Id: number;
  CirumferenceInnerPipe: number;
  PipeCount: number;
  NetStandardId: number;
  BracketsTotal: number;
  BracketsMooring: number;
  BracketsEvenlyDistr: number;
  PenDesignTypeId: number;
  MaterialClass: string;
  DesignBrackets: string;
  CapacityNetAttachmentULS: string;
  CapacityNetAttachmentALS: string;
  CapacityBottomRingSuspensionULS: string;
  CapacityBottomRingSuspensionALS: string;
  PenBridleConfigId: number;
  UserManualId: number;
  BulkHeadDistance: number;
  BottomRingDepth: number;
  RailingSDR: number;
  RailingDiameter: number;
  RailingSegmentLength: number;
  WalkwaySDR: number;
  WalkwayDiameter: number;

  PenDimensionPipes: PenDimensionPipeDto[];
}
